import {
  CheckMetadata,
  CheckMetadataItem,
  createSimpleCheckMetadataArray,
} from 'dashboard/components/ChecksTable/computeCheckMetadata';
import RiskLevelSticker from 'dashboard/components/RiskLevelSticker';
import { SelfieAgeThresholdComparison } from 'dashboard/models/check';

export const computeSelfieAgeThresholdComparisonMetadata = (
  check: SelfieAgeThresholdComparison,
): CheckMetadata => {
  let metadata = [] as CheckMetadataItem[];
  if (check.metadata && check.reasons) {
    const risks = check.metadata ? check.metadata['risks'] : null;
    const ageThresholdComparisonRiskData = risks?.find((r) => r.reason === 'age_outside_limits');

    const {
      'min-age-limit': minAgeLimit,
      'max-age-limit': maxAgeLimit,
      age,
      'age-range-low': ageRangeLow,
      'age-range-high': ageRangeHigh,
    } = check.metadata || {};
    const riskLevel = ageThresholdComparisonRiskData && ageThresholdComparisonRiskData.level;
    const displayMetadata = riskLevel && (minAgeLimit || maxAgeLimit);

    if (displayMetadata) {
      const metadataItems = [
        {
          label: 'Age Threshold Comparison Risk',
          value: RiskLevelSticker({ riskLevel: riskLevel }),
        },
      ] as Array<{ label: string; value: React.ReactNode }>;

      if (age) {
        metadataItems.push({ label: 'Estimated Age', value: `${age.toFixed(2)} years old` });
      } else {
        if (ageRangeLow) {
          metadataItems.push({
            label: 'Estimated Age Lower Bound',
            value: `${ageRangeLow} years old`,
          });
        }
        if (ageRangeHigh) {
          metadataItems.push({
            label: 'Estimated Age Upper Bound',
            value: `${ageRangeHigh} years old`,
          });
        }
      }

      if (minAgeLimit) {
        metadataItems.push({ label: 'Minimum Age Limit', value: `${minAgeLimit} years old` });
      }
      if (maxAgeLimit) {
        metadataItems.push({ label: 'Maximum Age Limit', value: `${maxAgeLimit} years old` });
      }

      metadata = createSimpleCheckMetadataArray(metadataItems);
    }
  }

  return {
    metadata,
    hideIfVerificationPassed: false,
  };
};
